import ThemeLookupsScene from '../scenes/ThemeLookupsScene';

const routes = [
  {
    path: '/theme-lookups/*',
    menuName: 'themeLookups_plural',
    component: ThemeLookupsScene,
    hasRight: 'theme-lookups/read',
  },
];

export default routes;
